<template>
  <div class="checkout-header-container">
    <v-container class="checkout-header">
      <div v-if="isAuth" class="pt-9 mb-5 d-flex stepper-container">
        <div class="d-flex align-center">
          <BackButton
            customBack
            @back="back"
          />
          <h1 class="text-h1 ml-2">{{ getCaption("CHECKOUT_HEADER") }}</h1>
        </div>
      </div>
      <div v-else-if="!isSuccess && !isCancel && !isNotEligible" class="pt-9 mb-5 d-flex stepper-container justify-space-between align-center">
        <div class="d-flex align-center">
          <BackButton
            customBack
            @back="back"
          />
          <div v-if="checkoutStep === 1" class="checkout-header__word">
            <h1 class="checkout-header__font ml-2">
              {{ isEmailStep ? getCaption("CHECKOUT_HEADER_STEP_1_EMAIL") : getCaption("CHECKOUT_HEADER_STEP_1") }}
            </h1>
            <span
              v-if="isEmailStep"
              class="checkout-header__subtitle ml-2"
            >
              {{ getCaption("CHECKOUT_HEADER_SUBTITLE_1_EMAIL") }}
            </span>
            <span
              v-else-if="userSingpass && checkoutSubStep === 2"
              class="checkout-header__subtitle ml-2"
            >
              {{ getCaption("CHECKOUT_HEADER_SUBTITLE_1_VERIFY") }}
            </span>
            <span
              v-else
              class="checkout-header__subtitle ml-2"
            >
              {{ getCaption("CHECKOUT_HEADER_SUBTITLE_1_CONFIRM") }}
            </span>
          </div>
          <div v-else-if="checkoutStep === 2" class="checkout-header__word">
            <h1 class="checkout-header__font ml-2">{{ getCaption("CHECKOUT_HEADER_STEP_2") }}</h1>
            <span class="checkout-header__subtitle ml-2">{{ getCaption("CHECKOUT_HEADER_SUBTITLE_2") }}</span>
          </div>
          <div v-else-if="checkoutStep === 3" class="checkout-header__word">
            <h1 class="checkout-header__font ml-2">{{ getCaption("CHECKOUT_HEADER_STEP_3") }}</h1>
            <span class="checkout-header__subtitle ml-2">{{ getCaption("CHECKOUT_HEADER_SUBTITLE_3") }}</span>
          </div>
        </div>
        <div>
          <v-progress-circular
            :value="progress"
            :size="42"
            :rotate="-90"
            color="#5579C6"
          >
            <span class="checkout-header__circle"> {{ checkoutStep }} of 3 </span>
          </v-progress-circular>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Options from 'vue-class-component'

import BackButton from '@/components/BackButton.vue'
import { getPath } from '@/utils/general-utils'
import { GetCaption as getCaption } from '@/utils/util.language'
import { DELETE_BOOKINGS } from '@/store/types'

@Options({
  components: {
    BackButton,
  },
  computed: mapGetters([
    'userSingpass',
    'checkoutStep',
    'checkoutSubStep'
  ]),
})
export default class Checkout extends Vue {

  checkoutStep!: number
  checkoutSubStep!: number
  userSingpass!: object | undefined
  getCaption = getCaption
  getPath = getPath

  get isEmailStep(): boolean {
    return !!this.userSingpass && this.checkoutSubStep === 1
  }

  get isAuth(): boolean {
    return this.$route.path.split('/').includes('auth')
  }

  get progress(): number {
    return 100 / 3 * this.checkoutStep
  }

  get isCancel(): boolean {
    return !!this.$route.query.cancel
  }

  get isNotEligible(): boolean {
    return !!this.$route.query.not_eligible
  }

  get isSuccess(): boolean {
    return !!this.$route.query.success
  }

  back(): void {
    this.$store.dispatch(DELETE_BOOKINGS)
    this.$router.push(getPath('/cart'))
  }
}

</script>

<style lang="scss" scoped>
.stepper-container {
  max-width: 100%;
  margin: auto;
  max-width: 500px;
}

.checkout-header {
  max-width: 100%;
  top: 28px;
  background-color: white;
  z-index: 120;

  &__word {
    line-height: 15px ;
  }

  &__font {
    font-size: 15px;
  }

  &__subtitle {
    font-size: 11px;
    letter-spacing: 1px;
  }

  &__circle {
    font-weight: 700;
    font-size: 10px;
    color: black;
  }
}
</style>